import PunctualityIcon from '@/widgets/PunctualityIcon.vue'
import { formatEta } from '@/utils/eta/format'
import { formatTime } from '@/utils/time/format'
import { deviation } from '@/utils/time/deviation'
import { parse } from '@/utils/time/parse'

const LATE_LOADING = 'LATE_LOADING'
const NO_POSITION_UPDATES = 'NO_POSITION_UPDATES'
const ESTIMATED_LATE_FINISH = 'ESTIMATED_LATE_FINISH'

export default {
    name: 'RouteCard',
    props: {
        route: Object,
        openRoute: Function,
    },
    components: {
        PunctualityIcon,
    },
    data: () => ({}),
    methods: {
        openThisRoute(event) {
            event.preventDefault()
            const url = event.target.closest('a').getAttribute('href')
            this.$props.openRoute(url)
        },
        hasIssue(issue) {
            const {
                route: { severity },
            } = this.$props
            return severity.issues.includes(issue)
        },
    },
    computed: {
        isOffline() {
            return this.hasIssue(NO_POSITION_UPDATES)
        },
        isLate() {
            return this.hasIssue(ESTIMATED_LATE_FINISH)
        },
        isLoading() {
            return this.hasIssue(LATE_LOADING)
        },
        formattedDeviation() {
            const {
                route: { punctuality },
            } = this.$props
            if (punctuality == null) {
                return ''
            }

            return formatTime(punctuality.deviationSeconds)
        },
        humanDeviation() {
            const {
                route: { punctuality },
            } = this.$props
            if (punctuality == null) {
                return ''
            }
            return deviation(punctuality.deviationSeconds)
        },
        eta() {
            const {
                route: { eta },
            } = this.$props
            if (eta == null) {
                return ''
            }
            return formatEta(parse(eta))
        },
    },
}
